<footer>
  <div class="container">
    <div class="copyright">
      <p class="font-14 txt-gray text-center">© 2020 - 2021 HRDoorway. All Rights Reserved</p>
    </div>
  </div>
</footer>
